import React from 'react';
import { LocalizeContext, LocalizeContextProps } from 'react-localize-redux';

/**
 * Outputs 'LocalizeContextProps' that is generally provided by 'withLocalize'
 * @see https://ryandrewjohnson.github.io/react-localize-redux-docs/#withlocalize
 */
function useLocalize() {
  return React.useContext<LocalizeContextProps>(LocalizeContext);
}

export default useLocalize;
